import { Dialog } from '@spiaggeit/spit-ui'
import { useTranslation } from 'react-i18next'
import { DialogProps } from '../../models/dialog-props.ts'
import { DangerousHtml } from '../DangerousHtml/DangerousHtml.tsx'

interface BookingPolicyDialogProps extends DialogProps {
  bookingPolicy?: string
}

export const BookingPolicyDialog = (props: BookingPolicyDialogProps) => {
  const { t } = useTranslation()
  const { bookingPolicy, ...rest } = props

  if (!bookingPolicy) return null

  return (
    <Dialog scrollContent size="md" title={t('common.bookingPolicy')} {...rest}>
      <DangerousHtml
        className="p-4"
        html={bookingPolicy.replace(/\n/g, '<br />')}
      />
    </Dialog>
  )
}
